import {TicketValidationStatus, ticketValidationStatus, TransportAssocEntity} from "@ots-frontend/ots-data";
import {Text, TextProps} from "@mantine/core";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {getFormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";

export type TicketValidationTextProps = Omit<TextProps, 'children'> & {
  data: TransportAssocEntity
  separator?: string
}

export const TicketValidationText = (props: TicketValidationTextProps) => {
  const {data, separator = ", ", ...rest} = props

  const {t} = useTranslation(["common"])

  const text = useMemo(() => {
    let desc = ""

    let status: TicketValidationStatus = ticketValidationStatus.pending
    if (!data.validationStatus || data.validationStatus === status) {
      desc += t(status.displayValue.id, status.displayValue.defaultMessage)
    } else {
      status = ticketValidationStatus.adminValidated
      desc += t(status.displayValue.id, status.displayValue.defaultMessage)
      desc += ": "
      if (data.adminValidatedDttm) {
        desc += data.adminValidatorName ?? t("common.unknown", "Unknown")
        desc += " (";
        desc += getFormattedDateTime(data.adminValidatedDttm)
        desc += ")";
      } else {
        desc += t("common.status.pending", "Pending")
      }
      desc += separator
      status = ticketValidationStatus.dispatchValidated
      desc += t(status.displayValue.id, status.displayValue.defaultMessage)
      desc += ": "
      if (data.dispatchValidatedDttm) {
        desc += data.dispatchValidatorName ?? t("common.unknown", "Unknown")
        desc += " (";
        desc += getFormattedDateTime(data.dispatchValidatedDttm)
        desc += ")";
      } else {
        desc += t("common.status.pending", "Pending")
      }
      desc += separator
      status = ticketValidationStatus.fieldValidated
      desc += t(status.displayValue.id, status.displayValue.defaultMessage)
      desc += ": "
      if (data.fieldValidatedDttm) {
        desc += data.fieldValidatorName ?? t("common.unknown", "Unknown")
        desc += " (";
        desc += getFormattedDateTime(data.fieldValidatedDttm)
        desc += ")";
      } else {
        desc += t("common.status.pending", "Pending")
      }
      desc += separator
      status = ticketValidationStatus.businessValidated
      desc += t(status.displayValue.id, status.displayValue.defaultMessage)
      desc += ": "
      if (data.businessValidatedDttm) {
        desc += data.businessValidatorName ?? t("common.unknown", "Unknown")
        desc += " (";
        desc += getFormattedDateTime(data.businessValidatedDttm)
        desc += ")";
      } else {
        desc += t("common.status.pending", "Pending")
      }
    }
    return desc
  }, [data, separator, t])


  return (
    <Text {...rest}>
      {text}
    </Text>
  )
}
